import React from 'react';
import { Link } from 'react-router-dom';

const SedePage = () => {
  const weekdaySchedule = [
    { time: '14:00 - 18:00', title: 'Doposcuola', desc: 'Compiti, studio assistito, attività educative', color: 'border-blue-500', bg: 'bg-blue-500/10' },
    { time: '18:00 - 20:00', title: 'Baby Boomer & Anziani', desc: 'Alfabetizzazione digitale, socializzazione', color: 'border-amber-500', bg: 'bg-amber-500/10' },
    { time: '20:00 - 22:00', title: 'Direttivo & Formazione', desc: 'Riunioni, corsi a distanza e in presenza', color: 'border-purple-500', bg: 'bg-purple-500/10' },
    { time: '22:00 - 23:00', title: 'Maieutica', desc: 'Sessioni di ascolto, mentoring e crescita personale', color: 'border-indigo-500', bg: 'bg-indigo-500/10' },
  ];

  return (
    <main data-testid="sede-page" className="pt-24">
      <section className="py-24">
        <div className="max-w-5xl mx-auto px-6">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Sharing della Sede</p>
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-8">
            Uno spazio<br />
            <span className="text-zinc-500">condiviso.</span>
          </h1>
          
          <p className="text-xl text-zinc-400 mb-16 max-w-2xl">
            Ogni ora è dedicata a chi ne ha più bisogno. Nessuno spazio sprecato.
          </p>

          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">//</span> Giorni Feriali
          </h2>
          
          <div className="space-y-4 mb-20">
            {weekdaySchedule.map((slot, i) => (
              <div key={i} className={`border-l-4 ${slot.color} ${slot.bg} p-6 card-hover`}>
                <div className="flex flex-col md:flex-row md:items-center gap-4">
                  <p className="font-mono text-lg text-white md:w-40">{slot.time}</p>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-white">{slot.title}</h3>
                    <p className="text-zinc-400 mt-1">{slot.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">//</span> Weekend
          </h2>
          
          <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-8">
            <h3 className="text-xl font-bold text-[#00FF41] mb-4">Famiglie ISEE Basso</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-white/10 p-6">
                <h4 className="font-bold text-white mb-2">Feste di Compleanno</h4>
                <p className="text-zinc-400 text-sm">Spesa sostenibile, accessibile a tutte le famiglie</p>
              </div>
              <div className="border border-white/10 p-6">
                <h4 className="font-bold text-white mb-2">Spazi Comuni</h4>
                <p className="text-zinc-400 text-sm">Per chi è solo: divorziati, separati, vedovi</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SedePage;
